import { FC } from 'react';
import { Document, Page, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 30,
  },
});

interface Props {
  dataUrl: string;
}

export const QrCodeDocument: FC<Props> = ({ dataUrl }) => {
  return (
    <Document>
      <Page size="A4" style={[styles.page]}>
        <Image src={dataUrl} />
      </Page>
    </Document>
  );
};
